var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcReloadCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "#F5F5F7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 11.5,
    stroke: "#CFD5E7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.955 6.00288C12.9682 5.99136 13.9678 6.25409 14.8617 6.76684C15.7555 7.27959 16.515 8.02588 17.07 8.93696V6.80088H18V9.58181C17.998 9.827 17.9065 10.0616 17.7452 10.235C17.5839 10.4083 17.3656 10.5067 17.1375 10.5088H14.5575V9.5012H16.2975C15.8294 8.72394 15.1855 8.087 14.4261 7.64998C13.6666 7.21297 12.8164 6.99016 11.955 7.0024C10.6734 6.95436 9.42598 7.4527 8.48473 8.38882C7.54347 9.32494 6.98463 10.623 6.93 12C6.98463 13.377 7.54347 14.6751 8.48473 15.6112C9.42598 16.5473 10.6734 17.0456 11.955 16.9976C13.2366 17.0456 14.484 16.5473 15.4253 15.6112C16.3665 14.6751 16.9254 13.377 16.98 12H17.91C17.8571 13.6428 17.2009 15.1962 16.0848 16.3202C14.9687 17.4442 13.4838 18.0471 11.955 17.9971C10.4262 18.0471 8.94129 17.4442 7.82522 16.3202C6.70914 15.1962 6.05285 13.6428 6 12C6.05285 10.3572 6.70914 8.80376 7.82522 7.6798C8.94129 6.55583 10.4262 5.95286 11.955 6.00288Z",
    fill: "#80828C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcReloadCircle);
export default __webpack_public_path__ + "static/media/ic_reload_circle.90b07c977c097bab6ae13cfdf52cb5cd.svg";
export { ForwardRef as ReactComponent };